<div class="ledger-wrapper">
  <div class="ledger-header">
    <h5 class="blue-text" data-pw="ledger_title" data-qa="ledger_title">Ledger</h5>
  </div>

  @if (transactions.length === 0) {
    <div class="ledger-empty" data-pw="ledger_empty_state" data-qa="ledger_empty_state">
      <span class="neutral-text">No transactions found</span>
    </div>
  } @else {
    <cfi-mat-table
      [data]="transactions"
      [columnDefinitions]="columnDefinitions"
      [displayedColumns]="displayedColumns"
      [columnsToDisplayWithExpand]="displayedColumns"
      [paginated]="true"
      [defaultPageSize]="5"
      [currentPageSize]="5"
      [pageSizeOptions]="[5, 10, 25]"
      [hidePageSizeSelector]="false"
      [striped]="true"
      [sortKey]="'distributionDate'"
      [sortDirection]="'desc'"
      data-pw="ledger_table"
      data-qa="ledger_table">

      <!-- Header Template -->
      <ng-template #headerTemplate let-column>
        {{ column.header }}
      </ng-template>

      <!-- Cell Template -->
      <ng-template #cellTemplate let-row let-column="column">
        @switch (column.name) {
          @case ('distributionDate') {
            <td data-pw="ledger_post_date_cell" data-qa="ledger_post_date_cell">
              {{ row.distributionDate | date: 'MM/dd/yyyy' }}
            </td>
          }
          @case ('academicYear') {
            <td data-pw="ledger_academic_year_cell" data-qa="ledger_academic_year_cell">
              {{ row.academicYear }}
            </td>
          }
          @case ('school') {
            <td data-pw="ledger_school_cell" data-qa="ledger_school_cell">
              {{ row.school }}
            </td>
          }
          @case ('program') {
            <td data-pw="ledger_program_cell" data-qa="ledger_program_cell">
              {{ row.program }}
            </td>
          }
          @case ('term') {
            <td data-pw="ledger_term_cell" data-qa="ledger_term_cell">
              {{ row.term }}
            </td>
          }
          @case ('distributedAmount') {
            <td data-pw="ledger_distributed_amount_cell" data-qa="ledger_distributed_amount_cell" class="amount-distributed">
              @if (row.distributedAmount) {
                {{ row.distributedAmount | currency: 'USD' : 'symbol' : '1.0-0' }}
              }
            </td>
          }
          @default {
            <td [attr.data-pw]="'cell-' + column.name" [attr.data-qa]="'cell-' + column.name">{{ row[column.name] }}</td>
          }
        }
      </ng-template>
    </cfi-mat-table>
  }
</div>
